<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <CreateClientComponent />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'
import CreateClientComponent from '@/components/backoffice/clients/CreateClientComponent.vue'

export default {
  name: 'CreateClient',

  components: {
    Layout,
    PageHeader,
    CreateClientComponent,
  },

  data() {
    return {
      title: 'Novo Cliente',
      items: [
        {
          text: 'BackOffice',
        },
        {
          text: 'Clientes',
        },
        {
          text: 'Novo Cliente',
          active: true,
        },
      ],
    }
  },
}
</script>
